import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';

export const selectFreightHandlingUnitPresets = (state) => get(state, 'freightHandlingUnitPresets', emptyObject);
export const selectFreightHandlingUnitPresetsById = (state, props) => get(selectFreightHandlingUnitPresets(state), props.id);
